import { useContext } from "react";
import { store } from "../store.js";

const useSetProcessOrganigram = () => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  
  const getProfils  = (organigram) => {

    var profils = []
    organigram.values && organigram.values.forEach(item => {
      
      profils.push({id:"" + item.id + "", item:item.item, isExpanded:false, isChecked:false, childs:[]})
      
      var childs = profils.filter(currentParent=> currentParent.id == "" +item.id + "")[0].childs
      
      item.Profil.details.forEach(detail => {
        childs.push({id:"" + detail.globalId + "", item:detail.key.value, isExpanded:false, isChecked:false, childs:[]})
        
      })
    })
    return profils
  
  }
 
  
  
  const getDecisions  = (process) => {
    var decisions = []
    process.values && process.values.forEach(item => {
      decisions.push({id:"" + item.id + "", item:item.item, isExpanded:false, isChecked:false, childs:[]})
      var childs = decisions.filter(currentParent=> currentParent.id == item.id)[0].childs
      item.WorkFlow.data.forEach(detail => {
        
        childs.push({id:"" + detail.globalId + "", smallId:detail.id, item:detail.items.data[0].item.item, isExpanded:false, isChecked:false, childs:[]})
        var decisionChilds = childs.filter(currentChild=> currentChild.id == detail.globalId)[0].childs
        
        detail.childs.forEach(childDetail => {
         
          var currentDecision = childDetail.items.data.filter(i => i.list == "Decisions")[0]
          currentDecision && decisionChilds.push({id:"" + currentDecision.item.globalId + "", item:currentDecision.item.item, isExpanded:false, isChecked:false, childs:[]})
          
        })
      })
    })
          
    return decisions
  }

  const setProcessOrganigram = (organigram, process, update=true) => {
    const payload = {profils: organigram && getProfils(organigram), decisions:process && getDecisions(process)}
    if (update == false)
      return payload
    dispatch({
      type: "SET_STEP",
      payload: payload,
    });
  };

  return setProcessOrganigram;
};

export default useSetProcessOrganigram;
